import { Card } from "@fanduel/og-fe-library";
import cx from "classnames";
import { useMemo } from "react";
import { USGSA_TRACK_SOURCE } from "@/constants/horseRacing";
import { Hr_Race } from "@/graphql/gql/graphql";
import { filterEmpty } from "@/utils/index";
import filterPicksByDataSource from "@/utils/racingPicks";
import RaceDetailsTable from "./RaceDetailsTable";
import styles from "./raceDetailsTable.module.scss";

interface RaceDetailsTableProps {
  race: Hr_Race;
  tab: 1 | 2;
  trackName: string | undefined | null;
  trackCode: string;
  trackDataSource: string | undefined | null;
}

const RaceDetailsTableContainer = ({
  race,
  tab,
  trackCode,
  trackName,
  trackDataSource,
}: RaceDetailsTableProps) => {
  const rows = useMemo(
    () =>
      filterEmpty(race.bettingInterests ?? [])?.sort(
        (betA, betB) =>
          Number.parseInt(betA?.runners?.[0]?.runnerId ?? "0", 10) -
          Number.parseInt(betB?.runners?.[0]?.runnerId ?? "0", 10)
      ) ?? [],
    [race]
  );

  const sourcesFilteredPicks = useMemo(() => {
    if (tab === 2) {
      return filterPicksByDataSource(
        filterEmpty(race.bettingInterests ?? []),
        trackDataSource ?? ""
      );
    }
    return [];
  }, [tab, race, trackDataSource]);

  if (tab !== 2) {
    return (
      <Card
        className={cx(styles.tableCard, styles.racePicksContainer)}
        variant="elevation"
        elevation="mid"
      >
        <div className={cx(styles.header, styles.singleHeader)}>
          <div className={styles.statsHeader}>Horse Stats</div>
        </div>
        <RaceDetailsTable
          rows={rows}
          race={race}
          trackCode={trackCode}
          trackName={trackName ?? ""}
        />
      </Card>
    );
  }

  const consensusPicksTitles = [] as string[];
  if (
    trackDataSource === USGSA_TRACK_SOURCE &&
    sourcesFilteredPicks.length === 2
  ) {
    consensusPicksTitles.push("numberFire Picks");
    consensusPicksTitles.push("Trackmaster Picks");
  } else if (trackDataSource === "SRW" && sourcesFilteredPicks.length === 1) {
    consensusPicksTitles.push("Free Picks");
  } else {
    consensusPicksTitles.push("numberFire Picks");
  }

  return (
    <div className={styles.racePicksContainer}>
      {sourcesFilteredPicks.map((pick, index) => (
        <Card
          className={styles.tableCard}
          key={consensusPicksTitles[index]}
          variant="elevation"
          elevation="mid"
        >
          <div className={styles.header}>
            <div className={styles.statsHeader}>
              {consensusPicksTitles[index]}
            </div>
            <div className={styles.statsHeader}>Horse Stats</div>
          </div>
          <RaceDetailsTable
            rows={pick}
            race={race}
            trackCode={trackCode}
            consensusView
            trackName={trackName ?? ""}
          />
        </Card>
      ))}
    </div>
  );
};

export default RaceDetailsTableContainer;
